<template>
    <div class="tabbar_container">
        <van-tabbar v-model="active" active-color="#ffbe0e" @change="gotourl(active)">
            <van-tabbar-item>
                <span>名片</span>
                <img
                slot="icon"
                slot-scope="props"
                :src="props.active ? icon.active01 : icon.normal01"
                >
            </van-tabbar-item>
            <van-tabbar-item>
                <span>圈子</span>
                <img
                slot="icon"
                slot-scope="props" 
                :src="props.active ? icon.active02 : icon.normal02"
                >
            </van-tabbar-item>
            <van-tabbar-item>
                <span>发现</span>
                <img
                slot="icon"
                slot-scope="props"
                :src="props.active ? icon.active03 : icon.normal03"
                >
            </van-tabbar-item>
            <van-tabbar-item>
                <span>我的</span>
                <img
                slot="icon"
                slot-scope="props"
                :src="props.active ? icon.active04 : icon.normal04"
                >
            </van-tabbar-item>
</van-tabbar>
    </div>
</template>

<script>
export default {
  data() {
    return {
      active:0,
      icon: {
        normal01: require('../../assets/images/home_btn_card_normal.png'),
        active01: require('../../assets/images/home_btn_card_selected.png'),
        normal02: require('../../assets/images/home_btn_circle_normal.png'),
        active02: require('../../assets/images/home_btn_circle_selected.png'),
        normal03: require('../../assets/images/home_btn_find_normal.png'),
        active03: require('../../assets/images/home_btn_find_selected.png'),
        normal04: require('../../assets/images/home_btn_my_normal.png'),
        active04: require('../../assets/images/home_btn_my_selected.png'),
      }
    };
  },created(){

		this.changetabbar();

    },
    
    methods:{
        
        gotourl:function(active){
			
			switch(active){
				case 0: 
                    //this.changetabbar(); 
					this.$router.push({ name:"mindex"});                    
					break;
				case 1: 
                    //this.changetabbar(); 
					this.$router.push({ name:"circle"});                   
					break;
				case 2: 
                    //this.changetabbar();
					this.$router.push({ name:"found"});                     
					break;
				case 3: 
                    //this.changetabbar();
					this.$router.push({ name:"mine"});                    
					//alert(active);
					break;
			}

            this.changetabbar();
			
        },
        changetabbar:function(){
				//判断当前的路由所在区域给
                this.onPath=this.$route.path;
				if(this.onPath=='/mine'){
					 
					 this.active= 3

				}else if(this.onPath=='/found'){
					
					this.active= 2

				}else if(this.onPath=='/circlelist' || this.onPath=='/circle' || this.onPath=='/circlevisit' || this.onPath=='/circlefollow'){
					this.active= 1

				}else if(this.onPath=='/found'){
					
					this.active= 2

				}

		}
		
    },
    activated(){

        this.changetabbar();
        
    }
    
};
</script>

<style scoped>
.tabbar_container{
    height: 3rem;
}
    .van-tabbar{ height:3rem;} 
    .van-tabbar-item__icon img { height:1.3rem}



</style>


// WEBPACK FOOTER //
// src/components/public/tabbar.vue